import { FC } from "react";
import { COLOR_WHITE } from "../colors";
import { IconType } from "./types";

export const HeadingOneIcon: FC<IconType> = ({ color = COLOR_WHITE }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4824 14.8203V17.1055H8.06055V14.8203H15.4824ZM8.92969 9.0293V23.248H6V9.0293H8.92969ZM17.5723 9.0293V23.248H14.6523V9.0293H17.5723Z"
      fill={color}
    />
    <path
      d="M26.6836 9V23.248H23.8711V12.2422L20.4922 13.3164V11.0996L26.3809 9H26.6836Z"
      fill={color}
    />
  </svg>
);
